"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _slateReact = require("slate-react");
var _slate = require("slate");
var _isHotkey = require("is-hotkey");
var _helpers = require("../../../helpers");
var _schema = require("./schema");
var _icon = _interopRequireDefault(require("./../../../../fonts/icon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const DEFAULT_NODE = 'paragraph';
const isBoldHotkey = (0, _isHotkey.isKeyHotkey)('mod+b');
const isItalicHotkey = (0, _isHotkey.isKeyHotkey)('mod+i');
const initialValue = _slate.Value.fromJSON({
  "object": "value",
  "document": {
    "object": "document",
    "data": {},
    "nodes": [{
      "object": "block",
      "type": "paragraph",
      "data": {},
      "nodes": [{
        "object": "text",
        "text": "",
        "marks": []
      }]
    }]
  }
});
class TMPRichText extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      value: (0, _helpers.isValidJson)(this.props.value) ? _slate.Value.fromJSON(JSON.parse(this.props.value)) : initialValue
    });
    _defineProperty(this, "hasMark", type => {
      const {
        value
      } = this.state;
      return value.activeMarks.some(mark => mark.type == type);
    });
    _defineProperty(this, "hasBlock", type => {
      const {
        value
      } = this.state;
      return value.blocks.some(node => node.type == type);
    });
    _defineProperty(this, "onChange", ({
      value
    }) => {
      this.setState({
        value
      });
      const {
        onChange
      } = this.props;
      if (onChange) {
        onChange(JSON.stringify(value.toJSON()));
      }
    });
    _defineProperty(this, "ref", editor => {
      this.editor = editor;
    });
    _defineProperty(this, "renderMarkButton", (type, icon) => {
      const isActive = this.hasMark(type);
      return /*#__PURE__*/_react.default.createElement("button", {
        type: 'button',
        className: 'btn btn-rich-text d-flex align-items-center justify-content-center ' + (isActive ? 'btn-primary' : 'btn-link'),
        onMouseDown: event => this.onClickMark(event, type)
      }, icon);
    });
    _defineProperty(this, "renderBlockButton", (type, icon) => {
      let isActive = this.hasBlock(type);
      if (['bulleted-list'].includes(type)) {
        const {
          value: {
            document,
            blocks
          }
        } = this.state;
        if (blocks.size > 0) {
          const parent = document.getParent(blocks.first().key);
          isActive = this.hasBlock('list-item') && parent && parent.type === type;
        }
      }
      return /*#__PURE__*/_react.default.createElement("button", {
        type: 'button',
        className: 'btn btn-rich-text d-flex align-items-center justify-content-center ' + (isActive ? 'btn-primary' : 'btn-link'),
        onMouseDown: event => this.onClickBlock(event, type)
      }, icon);
    });
    _defineProperty(this, "onKeyDown", (event, change, next) => {
      let mark;
      if (isBoldHotkey(event)) {
        mark = 'bold';
      } else if (isItalicHotkey(event)) {
        mark = 'italic';
      } else {
        return next();
      }
      event.preventDefault();
      change.toggleMark(mark);
    });
    _defineProperty(this, "onClickMark", (event, type) => {
      event.preventDefault();
      this.editor.change(change => {
        change.toggleMark(type);
      });
    });
    _defineProperty(this, "onClickBlock", (event, type) => {
      event.preventDefault();
      this.editor.change(change => {
        const {
          value
        } = change;
        const {
          document
        } = value;

        // Handle everything but the list buttons.
        if (type != 'bulleted-list') {
          const isActive = this.hasBlock(type);
          const isList = this.hasBlock('list-item');
          if (isList) {
            change.setBlocks(isActive ? DEFAULT_NODE : type).unwrapBlock('bulleted-list');
          } else {
            change.setBlocks(isActive ? DEFAULT_NODE : type);
          }
        } else {
          // Handle the extra wrapping required for list buttons.
          const isList = this.hasBlock('list-item');
          const isType = value.blocks.some(block => {
            return !!document.getClosest(block.key, parent => parent.type == type);
          });
          if (isList && isType) {
            change.setBlocks(DEFAULT_NODE).unwrapBlock('bulleted-list');
          } else {
            change.setBlocks('list-item').wrapBlock(type);
          }
        }
      });
    });
  }
  render() {
    const {
      value,
      onChange
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: 'form-control form-control-editor form-control-editor-tmp'
    }, /*#__PURE__*/_react.default.createElement(_slateReact.Editor, {
      spellCheck: true
      // autoFocus
      ,
      ref: this.ref,
      value: value || this.state.value,
      onChange: e => onChange(e, this.props),
      onKeyDown: this.onKeyDown,
      onPaste: this.onPaste,
      renderNode: _schema.renderNode,
      renderMark: _schema.renderMark
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: 'btn-toolbar slate-editor-toolbar'
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: 'btn-group btn-group-sm'
    }, this.renderMarkButton('bold', /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "format_bold",
      size: 16
    })), this.renderMarkButton('italic', /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "format_italic",
      size: 16
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: 'btn-group btn-group-sm'
    }, this.renderBlockButton('bulleted-list', /*#__PURE__*/_react.default.createElement(_icon.default, {
      icon: "format_list_bulleted",
      size: 16
    })))));
  }
}
var _default = exports.default = TMPRichText;
module.exports = exports.default;